// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetInterventionPriorityDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class AssetInterventionPriorityApiClient extends BaseCRUDApiClient<AssetInterventionPriorityDto> {
  baseUrl = this.config.apiEndpoint + '/asset-intervention-priority';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
